import { useEffect, useRef } from 'react';

/**
 * Hook para atualizar dados automaticamente em intervalos
 * @param {Function} fetchFunction - Função que busca os dados
 * @param {number} interval - Intervalo em ms (padrão: 5000 = 5 segundos)
 * @param {boolean} enabled - Se deve estar ativo (padrão: true)
 */
export const useAutoRefresh = (fetchFunction, interval = 5000, enabled = true) => {
  const intervalRef = useRef(null);
  const savedCallback = useRef(fetchFunction);
  const globalEnabledRef = useRef(true);

  useEffect(() => {
    savedCallback.current = fetchFunction;
  }, [fetchFunction]);

  useEffect(() => {
    try {
      const value = localStorage.getItem('autoRefreshEnabled');
      // Default: desabilitado para evitar múltiplas requisições
      globalEnabledRef.current = value === 'true';
    } catch (e) {
      globalEnabledRef.current = false;
    }
  }, []);

  useEffect(() => {
    if (!enabled || !globalEnabledRef.current) return;

    // Configura intervalo de polling
    intervalRef.current = setInterval(() => {
      if (savedCallback.current) {
        savedCallback.current();
      }
    }, interval);

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [enabled, interval]);
};

export default useAutoRefresh;
